"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryCode = exports.SortOrder = void 0;
var SortOrder;
(function (SortOrder) {
    SortOrder[SortOrder["PRIMARY"] = 1] = "PRIMARY";
    SortOrder[SortOrder["SECONDARY"] = 2] = "SECONDARY";
})(SortOrder || (exports.SortOrder = SortOrder = {}));
var CountryCode;
(function (CountryCode) {
    CountryCode["US"] = "+1";
    CountryCode["INDIA"] = "+91";
    CountryCode["PHILIPPINES"] = "+63";
})(CountryCode || (exports.CountryCode = CountryCode = {}));
